<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row v-if="!loadingData">
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto pb-0"
      >
        <v-btn
          color="darktext"
          class="rounded-xxl text-none white--text px-4"
          @click="goBack"
        >
          <v-icon>mdi-chevron-left</v-icon>{{ $t('backToActivity') }}
        </v-btn>
        <span class="float-right">
          <v-menu
            v-if="mobile()"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-2"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list
              class="menulist-drawer"
              data-testid="menu-list"
            >
              <v-list-item
                :class="{'v-list-item--active accent--text': $route.name === 'ActivityOverview'}"
                @click="showActivityOverview"
              >
                <v-list-item-title>{{ $t('overview') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :class="{'v-list-item--active accent--text': $route.name === 'PeopleInActivity'}"
                @click="showActivityMembers"
              >
                <v-list-item-title>{{ $t('people') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="role == 'booster'"
                :class="{'v-list-item--active accent--text': $route.name === 'BoostersInActivity'}"
                @click="showActivityOwners"
              >
                <v-list-item-title>{{ $t('owners') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="role == 'booster'"
                :class="{'v-list-item--active accent--text': $route.name === 'SurveysInActivity'}"
                @click="showActivitySurveys"
              >
                <v-list-item-title>{{ $t('surveys') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="role == 'booster'"
                :class="{'v-list-item--active accent--text': $route.name === 'ActivityReminders'}"
                @click="showActivityReminders"
              >
                <v-list-item-title>{{ $t('reminders') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
        <p class="text-h5 font-weight-bold pt-5" :align="mobile() ? 'center' : 'left'">
          {{ pageTitle }}
        </p>
        <p class="text-body-1 greytext--text d-none d-md-block">
          {{ pageText }}
        </p>
      </v-col>
      <v-col
        v-if="!mobile()"
        cols="11"
        class="mx-auto custom-tab-menu py-0"
      >
        <v-list
          class="py-0"
          flat
        >
          <v-list-item
            :class="{'v-list-item--active accent--text': $route.name === 'ActivityOverview'}"
            @click="showActivityOverview"
          >
            {{ $t('overview') }}
          </v-list-item> 
          <v-list-item
            :class="{'v-list-item--active accent--text': $route.name === 'PeopleInActivity'}"
            @click="showActivityMembers"
          >
            {{ $t('people') }}
          </v-list-item>
          <v-list-item
            v-if="role == 'booster'"
            :class="{'v-list-item--active accent--text': $route.name === 'BoostersInActivity'}"
            @click="showActivityOwners"
          >
            {{ $t('owners') }}
          </v-list-item>
          <v-list-item
          v-if="role == 'booster'"
            :class="{'v-list-item--active accent--text': $route.name === 'SurveysInActivity'}"
            @click="showActivitySurveys"
          >
            {{ $t('surveys') }}
          </v-list-item>
          <v-list-item
            v-if="role == 'booster'"
            :class="{'v-list-item--active accent--text': $route.name === 'ActivityReminders'}"
            @click="showActivityReminders"
          >
            {{ $t('reminders') }}
          </v-list-item>
        </v-list> 
      </v-col>
    </v-row>
    <router-view v-if="!loadingData" :role="role" :isOwner="isOwner" :can_share="can_share" :can_view_analytics="can_view_analytics"></router-view>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { getActivity } from '../../api/activityApi';
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        AlertMessages
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            alertMsg:'',
            alertType:'',
            alertValue:false,
            activityId: this.$route.params.id,
            loadingData: false,
            role:'',
            isOwner:'',
            can_share:false,
            can_view_analytics:false
        }
    },
    computed: {
        pageTitle() {
            if (this.$route.name === 'ActivityReminders') {
                return this.$t('activityRemindersTitle')
            }
            if (this.$route.name === 'SurveysInActivity') {
                return this.$t('surveys')
            }
            if (this.$route.name === 'BoostersInActivity') {
                return this.$t('owners')
            }
            if (this.$route.name === 'ActivityOverview') {
                return this.$t('overview')
            }
            return this.$t('peopleInActivityTitle')
        },
        pageText() {
            if (this.$route.name === 'ActivityReminders') {
                return this.$t('activityRemindersText')
            }
            return this.$t('peopleInActivityText')
        },
    },
    async created(){
        this.loadingData = true
        await this.getActivity()
        this.loadingData = false
    },
    methods:{
          async getActivity(){
            try {
                const response = await getActivity(this.activityId)
                if(response.status == 200) {
                    this.role = response.data.data.attributes.role,
                    this.isOwner = response.data.data.attributes.is_owner,
                    this.can_share = response.data.data.attributes.can_share
                    this.can_view_analytics = response.data.data.attributes.can_view_analytics
                }  
            } catch (e) {
                if(e.response){
                  if(e.response.status != 401 && e.response.status != 404){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                  }
                  if(e.response.status == 401){
                    this.flexibleData = true
                  }
                } 
            }
        }, 
        showActivityOverview(){
            if (this.$route.name != 'ActivityOverview') {
                this.$router.push({path: '/activity/'+ this.activityId +'/overview'})
            }
        },
        showActivityMembers(){
            if (this.$route.name != 'PeopleInActivity') {
                this.$router.push({path: '/activity/'+ this.activityId +'/people'})
            }
        },
        showActivityOwners(){
            if (this.$route.name != 'BoostersInActivity') {
                this.$router.push({path: '/activity/'+ this.activityId +'/owners'})
            }
        },
        showActivitySurveys(){
            if (this.$route.name != 'SurveysInActivity') {
                this.$router.push({path: '/activity/'+ this.activityId +'/surveys'})
            }
        },
        showActivityReminders(){
            if (this.$route.name != 'ActivityReminders') {
                this.$router.push({path: '/activity/'+ this.activityId +'/reminders'})
            }
        },
        goBack(){
            // this.$router.push({path: this.$router.back()}).catch(()=>{});
            this.$router.push({path: '/activity/'+ this.activityId})
        },
    },
}
</script>
